// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_cR9","cls2":"ReferenceEvaluationPage-cls2_Ul2 ReferenceEvaluationPage-cls1_cR9"};